"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hexToRgb = exports.handleThemeFromObject = exports.handleTheme = void 0;

require("core-js/modules/es6.regexp.split");

require("core-js/modules/es6.array.reduce");

require("core-js/modules/es6.regexp.replace");

var handleTheme = function handleTheme(theme, defaultValue, prop) {
  if (prop) {
    return prop;
  }

  if (theme) {
    return theme;
  }

  return defaultValue;
};

exports.handleTheme = handleTheme;

var toCamelCase = function toCamelCase(s) {
  return s ? s.replace(/(-\w)/g, function (m) {
    return m[1].toUpperCase();
  }) : s;
};

var handleThemeFromObject = function handleThemeFromObject() {
  var theme = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var key = arguments.length > 1 ? arguments[1] : undefined;
  var defaultValue = arguments.length > 2 ? arguments[2] : undefined;
  var prop = arguments.length > 3 ? arguments[3] : undefined;
  var acc = theme;
  var value = null;
  key.split('.').reduce(function (prevKey, currKey) {
    var curr = toCamelCase(currKey);
    var prev = toCamelCase(prevKey);

    if (acc) {
      value = acc[prev] ? acc[prev][curr] : null;
      acc = acc[prev];
      return curr;
    }

    return null;
  });
  return handleTheme(value, defaultValue, prop);
};

exports.handleThemeFromObject = handleThemeFromObject;

var hexToRgb = function hexToRgb(hex) {
  var opacity = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result ? "rgba(".concat(parseInt(result[1], 16), ", ").concat(parseInt(result[2], 16), ", ").concat(parseInt(result[3], 16), ", ").concat(opacity, ")") : hex;
};

exports.hexToRgb = hexToRgb;